// Registration form: shows the price of the checked dates and the bundle saving (the server computes it again).
const form = document.querySelector<HTMLFormElement>("[data-registration-form]")
const total = form?.querySelector<HTMLElement>("[data-total]")
const saving = form?.querySelector<HTMLElement>("[data-saving]")

if (form && total && saving) {
  const prices = JSON.parse(form.dataset.prices ?? "[]") as Array<number>
  const czk = new Intl.NumberFormat("cs-CZ", { style: "currency", currency: "CZK", maximumFractionDigits: 0 })
  const fill = (element: HTMLElement, token: string, amount: number | undefined) => {
    element.hidden = amount === undefined || amount <= 0
    element.textContent = element.hidden ? "" : (element.dataset.template ?? "").replace(token, czk.format(amount ?? 0))
  }
  const update = () => {
    const count = form.querySelectorAll('input[name="date"]:checked').length
    const price = prices[count - 1]
    const single = prices[0] ?? 0
    fill(total, "{price}", price)
    fill(saving, "{saving}", price === undefined ? undefined : count * single - price)
  }
  form.querySelector<HTMLElement>("[data-total-hint]")?.setAttribute("hidden", "")
  form.addEventListener("change", update)
  update()

  // A corrected field drops its error mark.
  form.addEventListener("input", (event) => {
    const field = (event.target as HTMLElement).closest(".field--invalid")
    if (!field) return
    field.classList.remove("field--invalid")
    field.querySelectorAll(".field__error").forEach((error) => error.remove())
    field.querySelectorAll("[aria-invalid]").forEach((input) => input.removeAttribute("aria-invalid"))
  })

  // After a failed submit the server re-renders the page from the top; bring the visitor to the form.
  const alert = form.querySelector<HTMLElement>("[data-form-alert]")
  if (alert) {
    alert.scrollIntoView({ block: "center" })
    alert.focus({ preventScroll: true })
  }
}
